"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestorType = exports.TimeUnit = exports.OptionGrantsType = exports.OptionGrantsVestingType = exports.NoteStatus = exports.TransactionType = exports.TrusteeType = exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["INDIVIDUAL"] = "individual";
    EntityType["COMPANY"] = "company";
    EntityType["TRUST"] = "trust";
    EntityType["SMSF"] = "smsf";
    EntityType["JOINT"] = "joint";
})(EntityType || (exports.EntityType = EntityType = {}));
var TrusteeType;
(function (TrusteeType) {
    TrusteeType["INDIVIDUAL"] = "individual";
    TrusteeType["COMPANY"] = "company";
})(TrusteeType || (exports.TrusteeType = TrusteeType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["ISSUE"] = "issue";
    TransactionType["TRANSFER"] = "transfer";
    TransactionType["ALLOCATE"] = "allocate";
    TransactionType["DISTRIBUTION"] = "distribution";
    /** Balance-reducing: a REDEEM row carries a negative quantity. */
    TransactionType["REDEEM"] = "redeem";
    TransactionType["ACCRUAL"] = "accrual";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var NoteStatus;
(function (NoteStatus) {
    NoteStatus["ISSUE"] = "issue";
    NoteStatus["CONVERTED"] = "converted";
    NoteStatus["PAID"] = "paid";
})(NoteStatus || (exports.NoteStatus = NoteStatus = {}));
var OptionGrantsVestingType;
(function (OptionGrantsVestingType) {
    OptionGrantsVestingType["TIME"] = "time";
    OptionGrantsVestingType["MANUAL"] = "manual";
})(OptionGrantsVestingType || (exports.OptionGrantsVestingType = OptionGrantsVestingType = {}));
var OptionGrantsType;
(function (OptionGrantsType) {
    OptionGrantsType["EMPLOYEE"] = "employee";
    OptionGrantsType["NON_EMPLOYEE"] = "non-employee";
})(OptionGrantsType || (exports.OptionGrantsType = OptionGrantsType = {}));
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["MONTH"] = "MONTH";
    TimeUnit["YEAR"] = "YEAR";
})(TimeUnit || (exports.TimeUnit = TimeUnit = {}));
var InvestorType;
(function (InvestorType) {
    InvestorType["SOPHISTICATED"] = "Sophisticated";
    InvestorType["CROWD_SOURCED"] = "Crowd-sourced";
    InvestorType["RETAIL"] = "Retail";
    InvestorType["EMPLOYEE"] = "Employee";
})(InvestorType || (exports.InvestorType = InvestorType = {}));
//# sourceMappingURL=index.js.map